import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import InputShowcase from './InputShowcase';
import { FILTERKEYS } from './constants';

const InputsList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map(group => (
        <section key={`${group}-input-group`}>
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul className="showcase-list">
            {
              dataGroup[group].map(group => (
                group.previews.map((inputs, i) => (
                  <li key={`input-${group.type}-showcase-${i}`}>
                    <InputShowcase {...inputs} />
                  </li>
                ))
              ))
            }
          </ul>
        </section>
      ))}
    </Fragment>
  );
};

InputsList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

InputsList.displayName = 'InputsList';

export default InputsList;


// WEBPACK FOOTER //
// ./src/containers/elements/Inputs/InputsList.js